module.exports = __webpack_public_path__ + "static/hero-cdba56f6a6ffb877480e03d79d3abfca.jpg";